import { render, staticRenderFns } from "./ItemTree.vue?vue&type=template&id=67b967ce&scoped=true"
import script from "./ItemTree.vue?vue&type=script&lang=ts"
export * from "./ItemTree.vue?vue&type=script&lang=ts"
import style0 from "./ItemTree.vue?vue&type=style&index=0&id=67b967ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b967ce",
  null
  
)

export default component.exports